<template>
  <el-card class="bg-white margin-top-xs  border-radius" header="供应链">
    <el-tree ref="tree" :data="treeData" :props="defaultProps" node-key="id" :expand-on-click-node="false"
      @node-click="handleNodeClick"></el-tree>
  </el-card>
</template>

<script>
import { listChainSupplier } from '@/api/admin/chainSupplier/chainSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChainSupplyTree',
  props: {
    callBackListener: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chainSupplyInfo: {
        chainSuppliers: [],
        csId: ''
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      }
    }
  },
  created() {
    this.listChainSuppliers()
  },
  mounted() {
  },
  methods: {
    listChainSuppliers() {

      listChainSupplier({
          page: 1,
          row: 100,
          shopId: getShopId()
        }).then(response => {
        const res = response
        this.chainSupplyInfo.chainSuppliers = res.data
        this.initTreeData()
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    initTreeData() {
      this.treeData = this.doJsTreeData()
      this.$nextTick(() => {
        if (this.chainSupplyInfo.csId) {
          this.$refs.tree.setCurrentKey('u_' + this.chainSupplyInfo.csId)
          return
        }
        if (this.treeData[0] && this.treeData[0].children[0]) {
          this.$refs.tree.setCurrentKey(this.treeData[0].children[0].id)
        }
      })
    },
    doJsTreeData() {
      const mFloorTree = []
      const chainSuppliers = this.chainSupplyInfo.chainSuppliers

      chainSuppliers.forEach(pItem => {
        const includeFloor = mFloorTree.some(item => pItem.csId === item.csId)

        if (!includeFloor) {
          const floorItem = {
            id: 'f_' + pItem.csId,
            csId: pItem.csId,
            text: pItem.name,
            suType: pItem.suType,
            children: this.doJsTreeMenuData(pItem.catalogs, pItem.csId, pItem.suType)
          }
          mFloorTree.push(floorItem)
        }
      })
      return mFloorTree
    },
    doJsTreeMenuData(catalogs, csId, suType) {
      return catalogs.map(item => ({
        id: 'u_' + item.catalogId,
        text: item.catalogName,
        catalogId: item.catalogId,
        catalogName: item.catalogName,
        csId: csId,
        seq: item.seq,
        suType: suType
      }))
    },
    handleNodeClick(data, node) {
      console.log(node)
      if (data.id.startsWith('f_')) {
        this.$emit('switchFloor', {
          suType: data.suType,
          csId: data.csId
        })
      } else {
        this.$emit('switchUnit', {
          csId: data.csId,
          suType: data.suType,
          catalogId: data.catalogId
        })
      }
    },
    getChainSupplierById(csId) {
      return this.chainSupplyInfo.chainSuppliers.find(item => item.csId === csId)
    },
    getChainSupplierCatalogById(csId, catalogId) {
      const supplier = this.getChainSupplierById(csId)
      if (supplier) {
        return supplier.catalogs.find(item => item.catalogId === catalogId)
      }
      return null
    }
  }
}
</script>

<style scoped>
.bg-white {
  background-color: #fff;
}

.margin-top-xs {
  margin-top: 10px;
}

.padding {
  padding: 15px;
}

.border-radius {
  border-radius: 4px;
}
</style>